// extracted by mini-css-extract-plugin
export default {"tabs":"index-module_tabs_hr0ML","tabsTitleList":"index-module_tabsTitleList_sj1Vl","tabTitle":"index-module_tabTitle_9vwuv"};